import { render, staticRenderFns } from "./standresident.vue?vue&type=template&id=0142b342&scoped=true"
import script from "./standresident.vue?vue&type=script&lang=js"
export * from "./standresident.vue?vue&type=script&lang=js"
import style0 from "./standresident.vue?vue&type=style&index=0&id=0142b342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0142b342",
  null
  
)

export default component.exports